import type * as React from 'react';
import { post } from '@Domain/Api';
import type { StaffMemberPayload } from '@Application/Facilities/StaffMembers/StaffMembers/Actions/staffMembersFetched';
import staffMemberCreated, {
	type StaffMemberCreatedAction,
} from '@Application/Facilities/StaffMembers/StaffMembers/Actions/staffMemberCreated';
import staffMemberCreationFailed, {
	type StaffMemberCreationFailedAction,
} from '@Application/Facilities/StaffMembers/StaffMembers/Actions/staffMemberCreationFailed';
import type CreateStaffMember from '@Application/Facilities/StaffMembers/StaffMembers/Commands/CreateStaffMember';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = StaffMemberCreatedAction | StaffMemberCreationFailedAction;

export default (command: CreateStaffMember) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<StaffMemberPayload>(
				`${parameters.api.host}/api/organizations/${command.organizationId}/staff-members`,
				command.toJSON(),
			);

			const action = staffMemberCreated(payload, command.organizationId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = staffMemberCreationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
